
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { InferGetStaticPropsType } from 'next'
import { Layout } from '@components/common'
import { TermsComponent } from '@components/terms'
import { getMenuCategories } from '@lib/api'
import { getDocumentContent, markdownToHtml } from '@lib/markdown'

 async function _getStaticProps() {
  const termsOfUseDocumentContent = getDocumentContent('termsOfUse.md')
  const termsOfSalesDocumentContent = getDocumentContent('termsOfSales.md')
  const menuCategories = await getMenuCategories()

  return {
    props: {
      menuCategories,
      termsOfUseContent: await markdownToHtml(termsOfUseDocumentContent),
      termsOfSalesContent: await markdownToHtml(termsOfSalesDocumentContent),
    },
  }
}

export default function Terms({
  termsOfUseContent,
  termsOfSalesContent,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <TermsComponent
      termsOfUseContent={termsOfUseContent}
      termsOfSalesContent={termsOfSalesContent}
    />
  )
}

Terms.Layout = Layout


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/terms',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  